import { TournamentEntity } from 'app/interfaces/entity';
import { sessionSelector } from 'app/store/session/selectors';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

export const useCurrentUserTeamId = (tournament?: TournamentEntity) => {
  const currentUser = useSelector(sessionSelector.activeUser);

  const currentUserTeamId = useMemo(
    () =>
      tournament?.teams?.find((team) =>
        team?.players?.some((player) => player?.userId === currentUser?.userId)
      )?.id,
    [tournament?.teams, currentUser]
  );

  return { currentUserTeamId };
};
